export const RENT_HEIGHT = `גובה שכר הדירה:`;
export const SUPPLY = `היצע:`;
export const LAST_MONTH = `מחודש שעבר`;
export const ROOM_NUMBER = `מספר חדרים:`;
